/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { apiClient } from './api';

export function getSurveyAssurancePortfolios(surveyId) {
  return apiClient.get('/assurances/portfolio/survey/' + surveyId)
    .then(response => response.data.data)
}

export function getSurveyAssurancePortfolio(assurancePortfolioId) {
  return apiClient.get(`/assurances/portfolio/${assurancePortfolioId}`)
    .then(response => response.data.data)
}

export function getSurveyAssurancePortfolioQuestions(portfolioId) {
  return apiClient.get(`/assurances/portfolio/${portfolioId}/questions`)
    .then(response => response.data.data)
}

export function downloadPortfolioBundle(portfolioId) {
  return apiClient.get(`/assurances/portfolio/${portfolioId}/download`)
    .then(response => response.data.data)
}

export function downloadMultipleQuestions(portfolioId, data) {
  return apiClient.post(`/assurances/portfolio/${portfolioId}/download/multiple`, data)
    .then(response => response.data.data)
}

export function downloadQuestionBundle(portfolioId, questionId) {
  return apiClient.get(`/assurances/portfolio/${portfolioId}/questions/${questionId}/download`)
    .then(response => response.data.data)
}

export function updateSurveyAssurancePortfolioQuestions(portfolioId, data) {
  return apiClient.post(`/assurances/portfolio/${portfolioId}/questions`, data)
    .then(response => response.data.data)
}

export const getAssurerList = () => apiClient
  .get('/assurances/assurers')
  .then((response) => response.data.data);

export function setAssurancePortfolioReady(portfolioId) {
  return apiClient.patch(`/assurances/portfolio/${portfolioId}/ready`)
    .then(response => response.data.data);
}

export function getDelegatedAssurers(portfolioId, data) {
  return apiClient.post(`/assurances/portfolio/${portfolioId}/questions/delegate`, data)
    .then(response => response.data.data)
}

export function delegateQuestions(portfolioId, data) {
  return apiClient.patch(`/assurances/portfolio/${portfolioId}/questions/delegate`, data)
    .then(response => response.data.data)
}

export function searchUserByAssurancePortfolio(escapedString, portfolioId) {
  return apiClient.get(`/assurances/portfolio/${portfolioId}/search?s=${escapedString}`)
    .then(response => response.data.data.map(d => {
      d.name = `${d.firstName} ${d.surname}`;
      return d;
    }));
}